import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import Snackbar from './modules/snackbar';
import Encoder from './modules/encoder';
import Decoder from './modules/decoder';
import SitemapAnalyzer from './modules/sitemapAnalyzer';
import WebpageAnalyzer from './modules/webpageAnalyzer';
import JSONPath from './modules/jsonPath';
import QueueUpScan from './modules/queueUpScan';
import QueueUpConfirm from './modules/queueUpConfirm';
import QueueUpStatus from './modules/queueUpStatus';
import QueueUpDisplay from './modules/queueUpDisplay';
import Normalizer from './modules/normalizer';
import FileConverter from './modules/fileConverter';
import Items from './modules/items';

export default new Vuex.Store({
    modules: {
        snackbar: Snackbar,
        decoder: Decoder,
        encoder: Encoder,
        sitemapAnalyzer: SitemapAnalyzer,
        webpageAnalyzer: WebpageAnalyzer,
        jsonPath: JSONPath,
        queueUpScan: QueueUpScan,
        queueUpConfirm: QueueUpConfirm,
        queueUpStatus: QueueUpStatus,
        queueUpDisplay: QueueUpDisplay,
        normalizer: Normalizer,
        fileConverter: FileConverter,
        items: Items
    }
});
